"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.settings.title': 'Ustawienia Czatu',
    'chat.settings.media_generation': 'Generowanie Mediów',
    'chat.settings.image_model': 'Model Obrazu',
    'chat.settings.video_model': 'Model Wideo',
    'chat.settings.voice.label': 'Głos',
    'chat.settings.chat_learning.label': 'Ucz się o użytkowniku z rozmowy czatu',
    'chat.settings.chat_learning.description': 'System będzie analizować Twoje rozmowy od czasu do czasu i dostosuje swój styl odpowiedzi do sposobu, w jaki wchodzisz w interakcję z systemem',
    'chat.settings.enable_ai_assistant.label': 'Włącz Asystenta AI',
    'chat.settings.enable_ai_assistant.description': 'Włącz Asystenta AI, aby zapewnić inteligentne sugestie i pomoc podczas rozmów',
    'chat.settings.enable_ai_assistant.disabled_tooltip': 'Asystent AI nie jest dostępny w Twoim obecnym planie. Prosimy o upgrade, aby uzyskać dostęp do tej funkcji.',
    'chat.settings.save': 'Zapisz',
    'chat.settings.saved': 'Ustawienia zapisane pomyślnie',
    'chat.settings.ai_parameters': 'Parametry AI',
    'chat.settings.temperature.label': 'Temperatura',
    'chat.settings.temperature.description': 'Kontroluje losowość w odpowiedziach AI. Niższe wartości sprawiają, że odpowiedzi są bardziej skoncentrowane i deterministyczne, wyższe wartości czynią je bardziej kreatywnymi i zróżnicowanymi.',
    'chat.settings.temperature.min_label': 'Ścisły',
    'chat.settings.temperature.max_label': 'Kreatywny',
    'chat.settings.assistance_setup': 'Konfiguracja Asystenta',
    'chat.settings.max_tokens.label': 'Długość Odpowiedzi',
    'chat.settings.max_tokens.description': 'Kontroluje maksymalną długość odpowiedzi AI. Domyślne używa ustawień modelu, inne opcje ograniczają długość odpowiedzi.',
    'chat.settings.max_tokens.default': 'Domyślne (Ustawienie Modelu)',
    'chat.settings.max_tokens.short': 'Krótkie',
    'chat.settings.max_tokens.medium': 'Średnie',
    'chat.settings.max_tokens.long': 'Długie',
    'chat.settings.extended_context.label': 'Rozszerzony Kontekst',
    'chat.settings.extended_context.description': 'Włącz tryb rozszerzonego kontekstu, aby zachować dłuższą pamięć konwersacji i lepsze zrozumienie poprzednich wiadomości',
    'chat.settings.thinking.label': 'Włącz Myślenie',
    'chat.settings.thinking.description': 'Pokaż rozumowanie AI i proces myślowy podczas generowania odpowiedzi',
};
